import React from "react";
import { SPECIES } from "./gameData";

const A = "/game-assets/";
// Grown = canonical stage-2 bodies (what the app's mature plants use).
const BODY_GROWN = {
  calathea: `${A}calathea.png`,
  pilea: `${A}pilea.png`,
  snake: `${A}snake.png`,
  cactus: `${A}cactus-leafling-body.png`,
  zz: `${A}zz.png`,
};
// Mid = canonical stage-1 bodies (younger, sparser) shown during play.
// Cactus has no staged art yet, so it falls back to its single body.
const BODY_MID = {
  calathea: `${A}calathea-mid.png`,
  pilea: `${A}pilea-mid.png`,
  snake: `${A}snake-mid.png`,
  cactus: `${A}cactus-leafling-body.png`,
  zz: `${A}zz-mid.png`,
};
const COSMETIC = {
  calathea: `${A}prop-glasses.png`,
  pilea: `${A}prop-squirrel.png`,
  cactus: `${A}prop-duck.png`,
};

// stage: "mid" (planted, growing) or "grown" (the bloom flourish). Since the
// bundled art is a single body per species, the grown stage is the same body
// presented larger, brighter, and crowned with a flower — the visible "it
// evolved!" payoff. Drop-in per-stage art can replace BODY_GROWN later.
// stage: "mid" (planted, growing) or "grown" (the bloom flourish / emblem).
// Emblem contexts (tray, draft, codex) default to grown; the in-play board
// passes "mid" and swaps to "grown" only for the bloom evolve moment.
export default function LeaflingSprite({ speciesId, owner = "you", plant, large = false, mood = "happy", stage = "grown", crown = false }) {
  // Distressed face when the plant is out of its healthy water band on either
  // extreme — bone dry (0 water) or overwatered past its max.
  const sp = SPECIES[speciesId];
  const unhappy = plant && (plant.water < 1 || (sp && plant.water > sp.waterMax));
  const body = (stage === "grown" ? BODY_GROWN : BODY_MID)[speciesId];
  return (
    <div className={`bb-sprite species-${speciesId} owner-${owner} stage-${stage} ${large ? "large" : ""} mood-${mood}`} aria-hidden="true">
      <div className="bb-sprite-aura" />
      {crown && <span className="bb-bloom-crown">❀</span>}
      {plant?.growLamp && <div className="bb-prop-lamp"><i /><span /></div>}
      {plant?.umbrella && <div className="bb-prop-umbrella"><i /><span /></div>}
      {plant?.humidifier && <div className="bb-prop-humidifier"><i /><b /><b /></div>}
      <div className="bb-sprite-body-wrap">
        <img className="bb-sprite-body" src={body} alt="" />
      </div>
      <div className="bb-sprite-pot-wrap">
        <img className="bb-sprite-pot" src={`${A}${owner === "sprout" ? "pot-pink" : "pot-yellow"}.png`} alt="" />
        <img className="bb-sprite-face eyes" src={`${A}${owner === "sprout" ? "eyes-rival" : "eyes-happy"}.png`} alt="" />
        <img className={`bb-sprite-face mouth ${unhappy ? "is-thirsty" : owner === "sprout" ? "is-rival" : "is-happy"}`} src={`${A}${unhappy ? "mouth-thirsty" : owner === "sprout" ? "mouth-rival" : "mouth-happy"}.png`} alt="" />
        {COSMETIC[speciesId] && !plant?.umbrella && <img className="bb-sprite-cosmetic" src={COSMETIC[speciesId]} alt="" />}
      </div>
    </div>
  );
}

export function EffectVignette({ cardId, speciesId = "calathea" }) {
  const fakePlant = {
    growLamp: cardId === "growLamp",
    humidifier: cardId === "humidifier",
    umbrella: cardId === "umbrella",
    water: cardId === "pests" ? 0 : 2,
  };
  return (
    <div className={`bb-effect-vignette effect-${cardId}`}>
      <div className="bb-effect-sky"><i /><i /><i /></div>
      <LeaflingSprite speciesId={speciesId} plant={fakePlant} large mood={cardId === "pests" || cardId === "rootRot" ? "worried" : "happy"} />
      <div className="bb-effect-particles">{Array.from({ length: 12 }, (_, i) => <i key={i} />)}</div>
      {cardId === "irrigation" && <div className="bb-irrigation-rig"><span /><span /><span /></div>}
      {cardId === "greenhouse" && <div className="bb-greenhouse-glass"><i /><i /><i /></div>}
      {cardId === "shovel" && <div className="bb-shovel-art"><i /><span /></div>}
      {cardId === "shopping" && <div className="bb-shopping-art"><span>✦</span><i /></div>}
      {cardId === "recycle" && <div className="bb-recycle-art">↻</div>}
      {cardId === "planter" && <div className="bb-planter-art"><i /><span>＋</span></div>}
    </div>
  );
}
